module.exports = __webpack_public_path__ + "img/compactLogogray.9e43d5a4.png";